var $ = jQuery;

jQuery(document).ready(function() {

  // Start Preload Stuff
    // Get Total Amount of slides
    var totalSlides = $('.swiper-slide').length;
    var slideString = totalSlides.toString();

    // Get URLs of the images
    var twSlide1 = $('.swiper-slide[data-hash="photo_0"] img').attr('src');
    var twSlide2 = $('.swiper-slide[data-hash="photo_1"] img').attr('src');
    var twSlide3 = $('.swiper-slide[data-hash="photo_2"] img').attr('src');
    
    var twSlide5 = $('.swiper-slide[data-hash="photo_3"] img').attr('src');

    // Console.log Stuff
    console.log("Total Slides :" + totalSlides);
    console.log("Slide 1 :" + twSlide1);
    console.log("Slide 2 :" + twSlide2);
    console.log("Slide 3 :" + twSlide3);
    console.log("Slide 5 :" + twSlide5);

  // End Preload Stuff

  $(".menu-item a").lettering();

  $(".moonrise").not(".journal-bar .moonrise").hover(function () {
    $(this).toggleClass("pink-sugar");
  });

  $(".children").not(".current_page_parent .children").hide();

  $("img").on("taphold", function(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  })

  $('.mobile-navigation .is-accordion-submenu').show();

  // Start Hiding Swiper for Tablet
  function is_touch_enabled() { 
    return ( 'ontouchstart' in window ) ||  
           ( navigator.maxTouchPoints > 0 ) || 
           ( navigator.msMaxTouchPoints > 0 ); 
  } 

  if( is_touch_enabled() ) { 
    $('.swiper-button-prev').hide();
    $('.swiper-button-next').hide();

    $('.arrow-cursor').hide();
    $('.arrow-cursor__icon').hide();        
  } 
  // Ends Hiding Swiper for Tablet

  var gallery = new Swiper ('.work-gallery-slider', {
    // Optional parameters
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 45,
    mousewheel: true,
    loop: true,
    // centeredSlides: true,
    // loopedSlides: 3,

    // preloadImages: true,
    // centeredSlides: true,

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // hashNavigation: {
    //   watchState: true,
    // },

    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },
  })

  var featuredSlider = new Swiper('.featured-post-slider', {
    // Optional parameters
    effect: 'fade',
    direction: 'horizontal',
    slidesPerView: '1',
    loop: true,
     // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 10000,
    },
  })
});

(function($) {

  /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */

  $.fn.visible = function(partial) {
    
      var $t            = $(this),
          $w            = $(window),
          viewTop       = $w.scrollTop(),
          viewBottom    = viewTop + $w.height(),
          _top          = $t.offset().top,
          _bottom       = _top + $t.height(),
          compareTop    = partial === true ? _bottom : _top,
          compareBottom = partial === true ? _top : _bottom;
    
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

  };
    
})(jQuery);

$(window).scroll(function(event) {
  
  $(".journal-card").each(function(i, el) {
    var el = $(el);
    if (el.visible(true)) {
      el.addClass("come-in"); 
    } 
  });
  
});

var win = $(window);
var allMods = $(".journal-card");

// Already visible modules
allMods.each(function(i, el) {
  var el = $(el);
  if (el.visible(true)) {
    el.addClass("already-visible"); 
  } 
});

win.scroll(function(event) {
  
  allMods.each(function(i, el) {
    var el = $(el);
    if (el.visible(true)) {
      el.addClass("come-in"); 
    } 
  });
  
});





// Hamburger Navigation

$('.is-accordion-submenu-parent > a').trigger('click');
var $hamburger = $(".hamburger");
$hamburger.on("click", function(e) {
  
  // $('.mobile-navigation .menu-item').not('.is-submenu-item').toggleClass('animate__animated animate__fadeInLeft animate__faster');
  // $('.is-submenu-item').toggleClass('animate__animated animate__flipInX animate__faster');
  // $('.mobile-navigation-social a').toggleClass('animate__animated animate__fadeIn animate__faster');

  $hamburger.toggleClass("is-active");

  $('.mobile-navigation').toggleClass('active-menu');
  $('body').toggleClass('gradient-nav');

  

  // Do something else, like open/close menu
});









$('.dropdown-parent').on("click", function(e) {
  $(this).toggleClass('active-dropdown-parent');
  $('.filter-categories').toggle();

  // $('.filter-left').toggleClass('small-6');
  // $('.filter-left').toggleClass('small-12');
  // $('.filter-right').toggleClass('show-for-large');
});

$('.search-field').focus(function(){
  $('.dropdown-parent').removeClass('active-dropdown-parent');
  $('.filter-categories').hide();

  $('.filter-right').removeClass('small-6');
  $('.filter-right').addClass('small-12');
  $('.filter-left').addClass('show-for-medium');
});

$('.search-field').focusout(function(){
  $('.filter-right').addClass('small-6');
  $('.filter-right').removeClass('small-12');
  $('.filter-left').removeClass('show-for-medium');
});